/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { Epic, ofType } from 'redux-observable';
import { switchMap, map, catchError, takeUntil, exhaustMap, tap, mapTo } from 'rxjs/operators';
import { cashboxesClient } from '../../../api/cashBoxes/cashboxesClient';
import { from, of } from 'rxjs';
import {
    CashBoxTimeDeltaTabActionType,
    CashBoxTimeDeltaTabAction,
    fetchCashBoxTimeDeltaHistorySuccessAction,
    fetchCashBoxTimeDeltaHistoryErrorAction,
    downloadTimeDeltaHistorySuccessAction,
    downloadTimeDeltaHistoryErrorAction,
} from '../../../actions/CashBoxRegistry/Tabs/cashBoxTimeDeltaTabActions';
import { downloadDataAsFile, parseError } from '../../../../utils/utils';
import { i18n } from '../../../translation/i18n';
import { AxiosError } from 'axios';

export const fetchCashBoxTimeDeltaHistoryEpic: Epic<CashBoxTimeDeltaTabAction> = (action$) => {
    return action$.pipe(
        ofType(CashBoxTimeDeltaTabActionType.FETCH_CASHBOX_TIME_DELTA_HISTORY),
        switchMap((action) => {
            const { taxNumber, params } = action.payload;
            const listName = i18n.t('RegistryScreens.cashBoxTimeHistory').toLowerCase();

            return from(cashboxesClient.getCashBoxTimeDeltaHistory(taxNumber, params)).pipe(
                map((resp) => {
                    return fetchCashBoxTimeDeltaHistorySuccessAction(resp);
                }),

                catchError((err: AxiosError) =>
                    of(
                        fetchCashBoxTimeDeltaHistoryErrorAction(
                            parseError(err, i18n.t('errors.failedLoadList', { listName })),
                        ),
                    ),
                ),

                takeUntil(action$.pipe(ofType(CashBoxTimeDeltaTabActionType.EXIT_CASHBOX_TIME_DELTA_TAB))),
            );
        }),
    );
};

export const cashBoxTimeDeltaHistoryDownloadEpic: Epic<CashBoxTimeDeltaTabAction> = (actions$) => {
    return actions$.pipe(
        ofType(CashBoxTimeDeltaTabActionType.DOWNLOAD_TIME_DELTA_HISTORY),
        exhaustMap((action) => {
            const { taxNumber, params } = action.payload;
            const fileName = `cashbox_${taxNumber}_TimeDeltaHistory.xls`;

            return from(cashboxesClient.downloadCashBoxTimeDeltaHistoryAsExcel(taxNumber, params)).pipe(
                tap((fileData) => downloadDataAsFile(fileName, fileData)),

                mapTo(downloadTimeDeltaHistorySuccessAction()),

                catchError((err: AxiosError) =>
                    of(
                        downloadTimeDeltaHistoryErrorAction(
                            parseError(err, i18n.t('errors.failedUploadFileName', { fileName })),
                        ),
                    ),
                ),
            );
        }),
    );
};
